module.exports = __webpack_public_path__ + "static/media/TUSD-logo.9fc5d5dc.png";